import type { GithubPullRequestsApi } from '@roadiehq/backstage-plugin-github-pull-requests';

/**
 * Searches GitHub pull requests, asking twice before trusting an empty answer.
 * GitHub's search sometimes returns no results for a query it hasn't run
 * lately, `author:@me` included, and the real ones a moment later. Roadie's
 * client queues its requests at least a second apart, so the second ask comes
 * after that pause.
 */
export const searchPullRequests = async (
  api: GithubPullRequestsApi,
  query: string,
) => {
  const first = await api.searchPullRequest({ query });
  return first.length > 0 ? first : api.searchPullRequest({ query });
};
